import store from '@/store'

export default function () {
    if (store.get('auth/token')) {
        return true
    } else if (localStorage.getItem('token')) {
        store.set('auth/token', localStorage.getItem('token'))

        return true;
    } else {
        return false
    }
}
